import { render } from "./ErrorPage.vue?vue&type=template&id=7116208d"
import script from "./ErrorPage.vue?vue&type=script&lang=js"
export * from "./ErrorPage.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./ErrorPage.vue?vue&type=style&index=0&id=7116208d&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script